import React from "react";
import { Formik } from "formik";
import {
    TextField,
    Paper,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem, FormGroup, FormControlLabel, Checkbox,
} from "@material-ui/core";
import * as Yup from "yup";
import {BackButton} from '../../sc-utilities';
import {
    diagnoseCaseExecutionTypes,
    diagnoseCaseGroups, supportedProductTypes
} from "../../sc-admin/AdminDiagnoseCase/AdminDiagnoseCaseDetails";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(1),
        margin: theme.spacing(1)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    licensing: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
    },
    icon: {
        color: 'rgb(220,220,220)',
    },
    assignedLicensesButton: {
        marginLeft: theme.spacing(),
    }
});

const CustomerDiagnoseCaseForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, OriginalShortName, OriginalLongName, OriginalVisible } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>

                            <FormGroup>
                                <FormControlLabel control={
                                    <Checkbox
                                        color="primary"
                                        margin={"dense"}
                                        name={"Visible"}
                                        checked={values.Visible}
                                        onChange={handleChange}
                                    />
                                }
                                   label={`${translations["visible"] || "Visible"} ${OriginalVisible!==null? `(${translations["default_value"] || "Default value"}: ${OriginalVisible? translations['yes'] || 'Yes' : translations['no'] || 'No'})` : ''}`}
                                />
                            </FormGroup>

                            <TextField
                                name="ShortName"
                                value={values.ShortName || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ShortName && touched.ShortName)}
                                placeholder={translations['short_name'] || 'Short name'}
                                label={`${translations['short_name'] || 'Short name'} ${OriginalShortName? `(${translations["default_value"] || "Default value"}: ${OriginalShortName})` : ''}`}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LongName"
                                value={values.LongName || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LongName && touched.LongName)}
                                placeholder={translations['long_name'] || 'Long name'}
                                label={`${translations['long_name'] || 'Long name'} ${OriginalLongName? `(${translations["default_value"] || "Default value"}: ${OriginalLongName})` : ''}`}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['group'] || 'Group'}</InputLabel>
                                <Select
                                    name="Group"
                                    label={translations['group'] || 'Group'}
                                    margin={"dense"}
                                    value={values.Group}
                                    onChange={handleChange}
                                    disabled={true}
                                >
                                    {(diagnoseCaseGroups(translations) ?? []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['execution_type'] || 'Execution type'}</InputLabel>
                                <Select
                                    name="ExecutionType"
                                    label={translations['execution_type'] || 'Execution type'}
                                    margin={"dense"}
                                    value={values.ExecutionType}
                                    onChange={handleChange}
                                    disabled={true}
                                >
                                    {(diagnoseCaseExecutionTypes(translations) ?? []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["product_type"] || "Product type"}</InputLabel>
                                <Select
                                    name="ProductType"
                                    label={translations["product_type"] || "Product type"}
                                    margin={"dense"}
                                    value={values.ProductType}
                                    onChange={handleChange}
                                    disabled={true}
                                >
                                    {supportedProductTypes(translations).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                name="Description"
                                value={values.Description || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations['description'] || 'Description'}
                                label={translations['description'] || 'Description'}
                                margin={"dense"}
                                fullWidth={true}
                                multiline
                                rows={3}
                                disabled={true}
                            />
                            <TextField
                                name="Key"
                                value={values.Key || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Key && touched.Key)}
                                placeholder={translations['key'] || 'Key'}
                                label={translations['key'] || 'Key'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />

                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};
export default withStyles(styles, { withTheme: true })(CustomerDiagnoseCaseForm);
